module.exports = __webpack_public_path__ + "media/images/photo/top/plan/plan-detail-background-b9c2a35293d9e98e9af0d326085eed8c.jpg";